import type { GroupVisibility } from './api';

export function visibilityLabel(v: GroupVisibility | string): string {
  return v.charAt(0).toUpperCase() + v.slice(1);
}
